import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../contexts/Web3StatusContext";
import TransactionStatus from '../TransactionStatus'

const { AccountData, ContractData, ContractForm } = newContextComponents;

class MoveTokensFromContract extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    amount: 0,
    address: '',
    tokenAddress: '',
    stackId: -1,
  };

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFORESTSale } = drizzle.contracts;

    var amount = this.context.web3.utils.toWei(this.state.amount.toString(), "ether");
    const stackId = GAMEFORESTSale.methods.transferERC20.cacheSend
        (this.state.tokenAddress, this.state.address, amount);
    this.setState({ stackId: stackId });
  }

  myAmountChangeHandler = (event) => {
    let { value } = event.target;
    const inputAmount = value;
    this.setState({amount: inputAmount});
  }

  myAddressChangeHandler = (event) => {
    let { value } = event.target;
    const address = value;
    this.setState({address: address});
  }

  myTokenAddressChangeHandler = (event) => {
    let { value } = event.target;
    const address = value;
    this.setState({tokenAddress: address});
  }

  // destructure drizzle and drizzleState from props
  render() {
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    var disabled = this.context.activeAccount == null;

    var form = (
    <form onSubmit={this.mySubmitHandler}>
        {statusMsg}<br/>
        Token Contract Address:{" "}
        <input
          value={this.state.tokenAddress}
          onChange={this.myTokenAddressChangeHandler}
        />
        <br/>
        Address:{" "}
        <input
          value={this.state.address}
          onChange={this.myAddressChangeHandler}
        />
        <br/>
        Amount:{" "}
        <input
          type="number"
          value={this.state.amount}
          onChange={this.myAmountChangeHandler}
        />
        <br/>
        <input
        type='submit'
        value="Transfer"
        disabled={disabled}
        />
        <br/>
    </form>
    );

    return (
      <div>
        {form}
      </div>
    );
  }
};

export default MoveTokensFromContract;
